import { AreaTypeBase } from './base/area-type-base';

export class AreaType extends AreaTypeBase { }